import React from 'react';
import './Rosette.css';

interface RosetteProps {
  count: number;
  size?: number;
}

/**
 * The brass rosette on the completion screen. Pops in once on mount — Sheet
 * remounts this component fresh each time the completion sheet opens.
 */
const Rosette: React.FC<RosetteProps> = ({ count, size = 112 }) => {
  const petals = Array.from({ length: 18 }, (_, i) => {
    const angle = (i / 18) * Math.PI * 2;
    return (
      <circle
        key={i}
        cx={60 + Math.cos(angle) * 46}
        cy={60 + Math.sin(angle) * 46}
        r={9}
        fill="var(--brass)"
      />
    );
  });

  return (
    <svg
      className="rosette"
      width={size}
      height={size}
      viewBox="0 0 120 120"
      aria-hidden="true"
    >
      {petals}
      <circle cx="60" cy="60" r="48" fill="var(--brass)" />
      <circle cx="60" cy="60" r="41" fill="var(--surface)" />
      <circle
        cx="60"
        cy="60"
        r="36"
        fill="none"
        stroke="var(--brass)"
        strokeWidth="2"
        strokeDasharray="4 5"
      />
      <text
        x="60"
        y="56"
        textAnchor="middle"
        fontFamily="Bevan, serif"
        fontSize="27"
        fill="var(--ink)"
      >
        {count}
      </text>
      <text
        x="60"
        y="76"
        textAnchor="middle"
        fontFamily="'Barlow Condensed', sans-serif"
        fontSize="13"
        fontWeight="700"
        letterSpacing="2.4"
        fill="var(--brass-ink)"
      >
        PUBS
      </text>
    </svg>
  );
};

export default Rosette;
